import React from 'react';
import { ethers } from 'ethers';
import { fmtUSDT } from '../../utils/format';

const ROWS = [
  { key: 'sponsorIncome', label: 'Sponsor (50%)',        color: 'yellow' },
  { key: 'levelIncome',   label: 'Level (30%)',          color: 'green' },
  { key: 'boosterIncome', label: 'Booster (10%)',        color: 'yellow' },
  { key: 'eliteRoyalty',  label: 'Elite Royalty (3%)',   color: 'green' },
  { key: 'proRoyalty',    label: 'Pro Royalty (3%)',     color: 'yellow' },
  { key: 'globalRoyalty', label: 'Global Royalty (4%)',  color: 'green' }
];

const IncomeBreakdown = ({ income }) => {
  const inc = income || {};
  const total = inc.totalIncomeGross ? ethers.BigNumber.from(inc.totalIncomeGross) : ethers.BigNumber.from(0);
  const totalNum = parseFloat(fmtUSDT(total).replace(/,/g, ''));

  return (
    <div className="card">
      <div className="card-title">Income Breakdown (Gross)</div>
      <div className="income-list" style={{ marginTop: 6 }}>
        {ROWS.map((r) => {
          const v = inc[r.key] || 0;
          const num = parseFloat(fmtUSDT(v).replace(/,/g, ''));
          const pct = totalNum > 0 ? Math.min(100, (num / totalNum) * 100) : 0;
          return (
            <div key={r.key}>
              <div className={`bd-row ${r.color === 'green' ? 'green' : ''}`}>
                <span className="lbl">{r.label}</span>
                <div className="bar"><div style={{ width: `${pct}%` }} /></div>
                <span className="val">{fmtUSDT(v)}</span>
              </div>
            </div>
          );
        })}
      </div>
      <div className="card-sub" style={{ marginTop: 10 }}>
        Wallet receives 95% of each credit. 5% admin fee accrues to the missing pool.
      </div>
    </div>
  );
};

export default IncomeBreakdown;
